<template>
  <button
    :disabled="isExporting"
    class="bg-slate-700 hover:bg-slate-600 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
    @click="handleExport"
  >
    <i class="fas fa-download text-xs"></i>
    {{ isExporting ? 'Exporting...' : label }}
  </button>
</template>

<script>
import { ref } from 'vue';
import { exportCollectionTemplateJson } from '@/utils/templateExport';

export default {
  props: {
    collectionName: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Export JSON',
    },
  },
  setup(props) {
    const isExporting = ref(false);

    const handleExport = async () => {
      if (isExporting.value) {
        return;
      }

      try {
        isExporting.value = true;
        const { copied, count } = await exportCollectionTemplateJson({
          collectionName: props.collectionName,
          fileName: props.fileName,
        });

        const clipboardMessage = copied
          ? 'และคัดลอก JSON ไปที่ clipboard แล้ว'
          : 'แต่คัดลอกไปที่ clipboard ไม่สำเร็จ';

        alert(`Export ${props.fileName} สำเร็จ ${count} รายการ ${clipboardMessage}`);
      } catch (error) {
        console.error(`Error exporting ${props.fileName}:`, error);
        alert(`เกิดข้อผิดพลาดในการ export ${props.fileName}`);
      } finally {
        isExporting.value = false;
      }
    };

    return {
      isExporting,
      handleExport,
    };
  },
};
</script>
